import { Grid, MenuItem, TextField } from '@material-ui/core';

/**
 * Capacity providers available for LMI (Lambda Managed Instances).
 * Empty value = not an LMI lambda.
 */
export const CAPACITY_PROVIDER_OPTIONS = [
  {
    value: 'lexid-capacity-provider',
    label: 'lexid-capacity-provider',
  },
  {
    value: 'phoenix-capacity-provider',
    label: 'phoenix-capacity-provider',
  },
];

interface CapacityProviderSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  fullWidth?: boolean;
  gridItem?: boolean;
}

export const CapacityProviderSelect = ({
  value,
  onChange,
  label = 'Capacity Provider (LMI)',
  fullWidth = true,
  gridItem = false,
}: CapacityProviderSelectProps) => {
  // A TextField with `select` manages the outlined notch itself, so the label is never cut by the
  // border line (unlike a hand-rolled FormControl + InputLabel + Select). InputLabelProps.shrink keeps
  // the label floated even when the value is empty, and SelectProps.displayEmpty makes MUI render the
  // empty-value MenuItem ("None (not LMI)") as the selected display instead of a blank field.
  const select = (
    <TextField
      select
      label={label}
      value={value || ''}
      onChange={e => onChange(e.target.value as string)}
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      InputLabelProps={{ shrink: true }}
      SelectProps={{ displayEmpty: true }}
    >
      <MenuItem value="">None (not LMI)</MenuItem>
      {CAPACITY_PROVIDER_OPTIONS.map(cp => (
        <MenuItem key={cp.value} value={cp.value}>
          {cp.label}
        </MenuItem>
      ))}
    </TextField>
  );

  if (gridItem) {
    return (
      <Grid item xs={12} md={4}>
        {select}
      </Grid>
    );
  }

  return select;
};
